import { AxiosInstance } from 'axios'

export type Disease = {
  id: number
  name: string
  description?: string | null
}

export function diseaseEndpoints(apiClient: AxiosInstance) {
  return {
    async getByName(name: string): Promise<Disease> {
      return apiClient.get(`get-disease-by-name/${name}`)
    },
    async list(): Promise<{ items: Disease[]; total: number }> {
      return apiClient.get(`disease`)
    },
  }
}
